import Request from './Request';
import { Route, Redirect, Switch } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';

const ForgotUsername = (props) => {
  const { match } = props;

  return (
    <Switch>
      <Route exact={true} path={`${match.path}/request`} component={Request} />

      <Redirect from={`${match.path}`} to={`${match.path}/request`} />
    </Switch>
  );
};

ForgotUsername.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default ForgotUsername;
